import { createApp } from 'vue/dist/vue.esm-bundler';

// 会員登録フォーム
import signup from "../components/SignupForm.vue"

// アプリケーションマウント
createApp({
  components: { signup }
}).mount('#signup-form')
